import {HotelBoxPlaceholder as NextHotelBoxPlaceholder} from '@/components/HotelBoxPlaceholder';
import {HotelBoxPlaceholderOld} from '@/components/HotelBoxPlaceholderOld';
import {useLocalSplit} from '@/modules/common/hooks';

type Props = {
  small?: boolean;
};

export const HotelBoxPlaceholder = ({small = false}: Props) => {
  const newHotelBoxSplit = useLocalSplit<
    'off' | 'on' | 'default' | 'on_2' | 'on_3'
  >('FFP_4783_new_hotel_box');
  const newHotelBoxEnabled =
    newHotelBoxSplit.ready &&
    (newHotelBoxSplit.treatment === 'on' ||
      newHotelBoxSplit.treatment === 'on_2' ||
      newHotelBoxSplit.treatment === 'on_3');

  return newHotelBoxEnabled ? (
    <NextHotelBoxPlaceholder small={small} />
  ) : (
    <HotelBoxPlaceholderOld small={small} />
  );
};
